import {Stack, Box, Typography} from '@mui/material';

const ExerciseVideos = ({exerciseVideos, name}) => {
  return (
    <Box sx={{marginTop: {xs: '20px', lg: '100px'}}} p='20px'>
      <Typography variant='h3' mb='40px'>
        Watch <span style={{color: '#ff2625', textTransform: 'capitalize'}}>{name}</span> exercise
        videos
      </Typography>

      <Stack
        justifyContent='flex-start'
        alignItems='center'
        flexWrap='wrap'
        sx={{flexDirection: {lg: 'row'}, gap: {xs: '0', lg: '110px'}}}
      >
        {exerciseVideos?.slice(0, 6).map((item, index) => (
          <a
            key={index}
            className='exercise-video'
            href={`https://www.youtube.com/watch?v=${item?.video?.videoId}`}
            target='_blank'
            rel='noreferrer'
          >
            <img src={item?.video?.thumbnails[0]?.url} alt={item?.video?.title} />
            <Box>
              <Typography variant='h5' mb={1} color='#000'>
                {item?.video?.title}
              </Typography>
              <Typography variant='h6' color='#000'>
                {item?.video?.channelName}
              </Typography>
            </Box>
          </a>
        ))}
      </Stack>
    </Box>
  );
};

export default ExerciseVideos;
